<div
  class="header-highligher"
  *ngIf="!sharedService.isSegmentPresent('searchboxMob')"
  [class.highlighter]="isScrolled"
></div>
<router-outlet />
<img
  [class.ar]="lang === 'ar'"
  [class.en]="lang === 'en'"
  src="assets/icons/whats-app-icon.svg"
  title="Whatsapp Icon"
  class="whatsapp-btn"
  (click)="onClickWhatsappBtn()"
/>
